import { Text } from '~/components/ui/text';

interface FieldHeaderProps {
  title: string;
  isMandatory: boolean;
}

const FieldHeader = ({ title, isMandatory }: FieldHeaderProps) => (
  <div className='flex flex-row items-center justify-start gap-2 mb-3'>
    <Text>{title}</Text>
    {isMandatory && <Text color='#878787'>(Mandatory)</Text>}
  </div>
);

export default FieldHeader;
